if (!customElements.get('wac-review-slider')) {
  customElements.define('wac-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[data-review-track]');
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      if (!this.track || !this.slides.length) return;
      this.index = 0;
      const update = () => {
        const position = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - position) < Math.abs(this.slides[best].getBoundingClientRect().left - position) ? i : best, 0);
        this.querySelector('[data-review-status]').textContent = `Review ${this.index + 1} of ${this.slides.length}`;
      };
      this.go = (direction) => {
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
        update();
      };
      this.querySelector('[data-review-prev]')?.addEventListener('click', () => this.go(-1), options);
      this.querySelector('[data-review-next]')?.addEventListener('click', () => this.go(1), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.track.addEventListener('scroll', () => { clearTimeout(this.scrollTimer); this.scrollTimer = setTimeout(update, 120); }, options);
      this.observer = new ResizeObserver(() => { this.track.scrollLeft = this.index * this.track.clientWidth; });
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.scrollTimer);
    }
  });
}
